import Phaser from 'phaser';

import pageParams from '../pageParams';

class DragPolygon extends Phaser.GameObjects.Polygon {
    constructor(scene, width, height) {
        super(scene, 0, 0, [0, 0, width, height]);

        scene.add.existing(this);

        this.setInteractive({ draggable: true });
        this.setOrigin(0);

        this.scene = scene;
        this.ball = scene.ball;
        this.joystick = scene.joystick;
        this.isPush = false;

        this.on('dragstart', ({ downX, downY }) => this.onPushStart(downX, downY));
        this.on('drag', ({ position: { x, y } }) => this.onPush(x, y));
        this.on('dragend', () => this.onPushEnd());
    }

    onPushStart(x, y) {
        if (!this.scene.hold && this.scene.isMoveAbility && this.scene.keysDown.length === 0) {
            if (pageParams.screenSize === 's' || pageParams.screenSize === 'm') this.scene.sys.game.handleHideRule();
            this.downX = x;
            this.downY = y;
            this.isPush = true;
            this.joystick.changeVisibility(true, x, y);
        }
    }

    onPush(x, y) {
        if (!this.scene.hold && this.isPush) {
            this.ball.push((x - this.downX) * 1.2, (y - this.downY) * 1.2);
            this.joystick.changeJoystickPosition(x, y);
        }
    }

    onPushEnd() {
        if (this.isPush && this.scene.isMoveAbility) {
            this.ball.loose();
            this.hideJoystick();
        }
        this.isPush = false;
    }

    hideJoystick() {
        this.joystick.changeJoystickPosition(this.downX, this.downY);
        this.joystick.changeVisibility();
    }
}

export default DragPolygon;
